// extracted by mini-css-extract-plugin
module.exports = {"Breadcrumbs":"breadcrumbs_Breadcrumbs__CmKqV","Crumb":"breadcrumbs_Crumb__1Ce7H","Content":"breadcrumbs_Content__VnPuZ"};